/**
 * 小程序样式配置
 */
<template>
  <div>
    
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>小程序样式</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：" prop="keyword">
        <el-input size="small" clearable style="width: 300px" v-model="formInline.keyword" placeholder="输入属性、属性值、样式描述"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" :cell-style="tableRowStyle" stripe :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" type="index" width="60">
      </el-table-column>
      <el-table-column sortable prop="id" label="主键" v-if="false" width="100" show-overflow-tooltip>
      </el-table-column>
      <el-table-column sortable align="center" prop="fieldkey" label="属性名" width="200">
        <template slot-scope="scope">
          <div slot="reference" class="name-wrapper">
            <el-tag effect="light" size="medium">{{ scope.row.fieldkey }}</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="filedval" label="属性值" width="300">
      </el-table-column>
      <el-table-column sortable prop="description" label="样式描述" width="300">
      </el-table-column>
      <el-table-column sortable prop="isuse" label="是否使用" width="100">
        <template slot-scope="{row}">
            <div style="color:green;" v-if="row.isuse == 1">
                是
            </div>
            <div style="color:red;" v-else-if="row.isuse == 0">
                否
            </div>
            <div v-else>
                {{row.isuse}}
            </div>
        </template>
      </el-table-column>
      <el-table-column sortable prop="createtime" label="创建时间" width="100">
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="100">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click="closeDialog">
      <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
        <el-form-item label="属性名" prop="fieldkey">
          <el-input size="small" v-model="editForm.fieldkey" :disabled="title == '修改'" auto-complete="off" placeholder="请输入属性名"></el-input>
        </el-form-item>
        <el-form-item label="属性值" prop="filedval">
          <!-- <el-input size="small" v-model="editForm.filedval" auto-complete="off" placeholder="请输入属性值"></el-input> -->
          <el-input type="textarea" :rows="4" size="small" resize="none" v-model="editForm.filedval" autocomplete="off" placeholder="请输入属性值"></el-input>
        </el-form-item>
        <el-form-item label="属性描述" prop="description">
          <el-input type="textarea" :rows="6" size="small" resize="none" v-model="editForm.description" autocomplete="off" placeholder="请输入属性描述"></el-input>
        </el-form-item>
        <el-form-item label="是否使用" prop="isuse">
          <el-select v-model="editForm.isuse" clearable placeholder="请选择">
            <el-option
              v-for="item in isuse"
              :key="item.id"
              :label="item.text"
              :value="item.val">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间" prop="createtime">
          <el-date-picker v-model="editForm.createtime" type="datetime" disabled auto-complete="off" ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {  WxStyleConfList,WxSaveStyleConf } from '../../api/basisMG'
import Pagination from '../../components/Pagination'
import {dateFormat} from '../../utils/datetime'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      isuse: [{text:'是',val:'1'},{text:'否',val:'0'}],
      editForm: {
        id: '',
        fieldkey: '',
        filedval: '',
        description: '',
        isuse: '',
        createtime: '',
        token: localStorage.getItem('logintoken')
      },
      // rules表单验证
      rules: {
        fieldkey: [
          { required: true, message: '请输入属性名', trigger: 'blur' }
        ],
        filedval: [{ required: true, message: '请输入属性值', trigger: 'blur' }],
        description: [{ required: true, message: '请输入属性描述', trigger: 'blur' }]
      },
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      // 删除部门
      seletedata: {
        ids: '',
        token: localStorage.getItem('logintoken')
      },
      userparm: [], //搜索权限
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    // 获取公司列表
    getdata(parameter) {
      this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      WxStyleConfList(parameter)
        .then(res => {
          console.log(res)
          this.loading = false
          if (res.result != 'success') {
            this.$message({
              type: 'info',
              message: '请求失败'
            })
          } else {
            this.listData = res.list
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.count
          }
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.$message.error(err.response.statusText)
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    tableRowStyle({row, column, rowIndex, columnIndex }){
      if(row.fieldkey === 'huang'){
      //张三的那一行所有字体颜色都是红色
        return 'color:red;!important;'
      }
      if(columnIndex === 2){
      //第3列字体颜色是红色
        return 'font-size: 14px;color:#c285f1;font-weight: bold;font-family:"微软雅黑"; !important;'
      }
      if(row.filedval === 'huang' && columnIndex === 3){
      //张三的那一行第3列字体颜色是红色
        return 'color:red;!important;'
      }
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.id = row.id
        this.editForm.fieldkey = row.fieldkey
        this.editForm.filedval = row.filedval
        this.editForm.description = row.description
        this.editForm.isuse = row.isuse
        this.editForm.createtime = row.createtime
      } else {
        this.title = '添加'
        this.editForm.id = ''
        this.editForm.fieldkey = ''
        this.editForm.filedval = ''
        this.editForm.description = ''
        this.editForm.isuse = ''
        this.editForm.createtime = dateFormat(new Date())
      }
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          WxSaveStyleConf(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              console.log(res)
              if (res.result === 'success') {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.result
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('保存失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 关闭编辑、增加弹出框
    closeDialog() {
      this.editFormVisible = false
      this.$refs['editForm'].resetFields();
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
</style>

 
 


// WEBPACK FOOTER //
// src/views/miniBase/MiniStyle.vue